import { render, staticRenderFns } from "./ClickBank.vue?vue&type=template&id=5bafe988&"
import script from "./ClickBank.vue?vue&type=script&lang=js&"
export * from "./ClickBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports